
export default {
  props: {
    propListColumnCount: {
      type: Number,
      default: 4,
    },
    swexMarketPrice: {
      type: [String, Number],
      default: null,
    },
    lastTradePrice: {
      type: [String, Number],
      default: null,
    },
    distilleryRating: {
      type: [String, Number],
      default: null,
    },
    remainingYearsTillMaturation: {
      type: Number,
      default: null,
    },
  },
}
